import { Container, Divider, TabPanel, TabPanels } from '@chakra-ui/react';
import ButtonCreateNew from 'components/ui/ButtonCreateNew';
import HeaderBar from 'components/ui/HeaderBar';
import Lists from '../components/Lists';
import ListsCompanyView from '../components/ListsCompanyView';
import ListsTagView from '../components/ListsTagView';

export default function PageLists() {
  return (
    <>
      <HeaderBar
        title="Listas de Disparo"
        description="Visualize a gerencie listas de disparo Patri"
      >
        <ButtonCreateNew 
          title="Cadastrar nova"
          to="/listas-de-disparo/nova"
        />          
      </HeaderBar>
      
      <Divider />
      
      <Container flexDirection="column">
        <Lists>
          <TabPanels mt="85px">
            <TabPanel>
              <ListsCompanyView />
            </TabPanel>
            <TabPanel>
              <ListsTagView />
            </TabPanel>
          </TabPanels>
        </Lists>
      </Container>
    </>    
  )
}
